var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelSvgrepocom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.213 19.0392L10.1907 16.7451V33.6969C10.1908 33.881 10.2273 34.0634 10.2979 34.2334C10.3685 34.4035 10.4719 34.558 10.6022 34.6882C10.7326 34.8183 10.8873 34.9214 11.0575 34.9918C11.2277 35.0621 11.41 35.0982 11.5942 35.0981H34.0648C34.2491 35.0985 34.4318 35.0626 34.6023 34.9924C34.7727 34.9222 34.9277 34.8191 35.0583 34.689C35.1889 34.5588 35.2925 34.4042 35.3633 34.234C35.434 34.0638 35.4705 33.8812 35.4707 33.6969V27.451L23.213 19.0392Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.213 4.50983H11.5942C11.41 4.50967 11.2277 4.54579 11.0575 4.61612C10.8873 4.68646 10.7326 4.78962 10.6022 4.91973C10.4719 5.04985 10.3685 5.20435 10.2979 5.37444C10.2273 5.54452 10.1908 5.72684 10.1907 5.911V12.1569L23.213 19.8039L30.1083 22.0981L35.4707 19.8039V12.1569L23.213 4.50983Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1907 12.1569H23.213V19.8039H10.1907V12.1569Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.1,
    d: "M19.5107 10.6274H10.1907V29.7451H19.5107C19.882 29.7432 20.2377 29.5951 20.5007 29.3329C20.7636 29.0706 20.9126 28.7153 20.9154 28.3439V12.0286C20.9126 11.6573 20.7636 11.3019 20.5007 11.0397C20.2377 10.7774 19.882 10.6293 19.5107 10.6274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.2,
    d: "M18.7448 11.3922H10.1907V30.5098H18.7448C19.1162 30.508 19.4719 30.3598 19.7348 30.0976C19.9977 29.8353 20.1467 29.48 20.1495 29.1086V12.7933C20.1467 12.422 19.9977 12.0666 19.7348 11.8044C19.4719 11.5421 19.1162 11.394 18.7448 11.3922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M18.7448 11.3922H10.1907V28.9804H18.7448C19.1162 28.9785 19.4719 28.8304 19.7348 28.5682C19.9977 28.3059 20.1467 27.9506 20.1495 27.5792V12.7933C20.1467 12.422 19.9977 12.0666 19.7348 11.8044C19.4719 11.5421 19.1162 11.394 18.7448 11.3922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.2,
    d: "M17.9789 11.3922H10.1907V28.9804H17.9789C18.3503 28.9785 18.706 28.8304 18.9689 28.5682C19.2318 28.3059 19.3808 27.9506 19.3836 27.5792V12.7933C19.3808 12.422 19.2318 12.0666 18.9689 11.8044C18.706 11.5421 18.3503 11.394 17.9789 11.3922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M3.93412 11.3922H17.9788C18.3509 11.3918 18.7078 11.5393 18.9712 11.802C19.2346 12.0647 19.3829 12.4213 19.3835 12.7933V26.8145C19.3829 27.1865 19.2346 27.5431 18.9712 27.8058C18.7078 28.0686 18.3509 28.216 17.9788 28.2157H3.93412C3.74987 28.216 3.56735 28.18 3.39702 28.1097C3.22668 28.0395 3.07186 27.9363 2.94141 27.8062C2.81095 27.6761 2.70742 27.5215 2.63673 27.3513C2.56604 27.1812 2.52957 26.9988 2.52942 26.8145V12.7933C2.52957 12.6091 2.56604 12.4266 2.63673 12.2565C2.70742 12.0863 2.81095 11.9318 2.94141 11.8016C3.07186 11.6715 3.22668 11.5684 3.39702 11.4981C3.56735 11.4278 3.74987 11.3918 3.93412 11.3922Z",
    fill: "url(#paint0_linear_757_3005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.88245 24.3604L9.83656 19.791L7.13068 15.2474H9.30362L10.7801 18.1568C10.9166 18.4321 11.0154 18.6368 11.0601 18.7733H11.0801C11.1766 18.5521 11.2789 18.3392 11.386 18.131L12.9648 15.2521H14.9648L12.1895 19.7698L15.0354 24.3639H12.9072L11.2013 21.1745C11.1221 21.0374 11.0548 20.8937 11.0001 20.7451H10.9719C10.9221 20.8899 10.8558 21.0285 10.7742 21.158L9.01774 24.3604H6.88245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.066 4.50983H23.213V12.1569H35.4707V5.91101C35.4705 5.72675 35.434 5.54432 35.3633 5.37417C35.2927 5.20401 35.1891 5.04945 35.0587 4.91932C34.9282 4.78919 34.7734 4.68605 34.6031 4.61579C34.4327 4.54553 34.2502 4.50952 34.066 4.50983Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M23.213 19.804H35.4707V27.451H23.213V19.804Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_757_3005",
    x1: 5.46354,
    y1: 10.291,
    x2: 16.4494,
    y2: 29.3169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelSvgrepocom1);
export default __webpack_public_path__ + "static/media/excel_svgrepo.com (1).dd4082fb779e677f71375042ac2ae014.svg";
export { ForwardRef as ReactComponent };